import IRequest from "../../IRequest";

export interface ISituacaoFinanceira {
    reqSituacoes: IRequest<TSituacaoFinanceira>,
    dataSituacoes: TSituacaoFinanceira[]
  }

export type TSituacaoFinanceira = {
  id: number;
  nome: string;
  considera_fechamento_cc: 'S' | 'N';
  considera_fluxo_caixa: 'S' | 'N';
}

export const defValueSituacaoFinanceira = {
    id: 0,
    nome: '',
    considera_fechamento_cc: 'N',
    considera_fluxo_caixa: 'N',
}